import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import BottomNav from '@/components/BottomNav';
import { defaultRules } from '@/consts';

const getColor = (index, index_) => {
  if (index === 4 && index_ % 2 !== 0) return 'error';
  if (index === 3 && index_ % 2 === 0) return 'error';
  if ((index === 1 && index_ === 15) || (index === 1 && index_ === 16)) return 'error';

  return 'text.primary';
};

export default function EventRulesFaq() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [expanded, setExpanded] = useState(
    globalThis.location.hash.replace(/#|panel-|-content|-header/, ''),
  );
  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <Container component="main" maxWidth="xl">
      <Box component={Paper} sx={{ my: 4, padding: 2 }}>
        <Typography gutterBottom variant="h2" component="h1" className="font-bebas">
          {t('rules.title')}
        </Typography>
        {defaultRules.map((faq, index) => {
          const id = faq.question.split('.').slice(1, -1)[0];

          return (
            <Accordion
              key={id}
              expanded={expanded === id}
              onChange={handleChange(id)}
              elevation={2}
            >
              <AccordionSummary aria-controls={`panel-${id}-content`} id={`panel-${id}-header`}>
                <Typography variant="h5" fontWeight="bold">
                  {t(faq.question)}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {t(faq.answer)
                  .split('\n')
                  .map((line, index_) =>
                    line.trim() ? (
                      <Typography
                        key={line}
                        variant="body1"
                        sx={{ marginBottom: '16px' }}
                        color={getColor(index, index_)}
                      >
                        {line}
                      </Typography>
                    ) : null,
                  )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
      {isMobile && <BottomNav />}
    </Container>
  );
}
